import React from 'react';

import usePreCompRegistrationOrganizationContactsDetail from './UsePreCompRegistrationOrganizationContactsDetail';

import PreCompRegistrationConstants from '../utils/PreCompRegistrationConstants';

import PreCompLocationStaffDupGrid from '../../preComp/components/grids/PreCompLocationStaffDupGrid';
import PreCompOrganizationContactForm from '../../preComp/components/forms/PreCompOrganizationContactForm';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import LeftNav from '@usas/ui-web/components/leftNav/LeftNav';
import Constants from '@usas/ui-web/utils/Constants';

const PreCompRegistrationOrganizationContactsDetail = () => {
  const {
    isLoading,
    isDelete,
    formState,
    errorState,
    dupGridState,
    newGridState,
    roleOptionsState,
    locationRegistrationNavState,
    existingContactModalState,
    displayLocalDupPersonModalState,
    onFormValueChanged,
    handleSubmit,
    onValueTextPairChanged,
    onCancelClicked,
    onModalCancelClicked,
    onModalContinueClicked,
    onSelectGridPerson,
    onExistingContactModalConfirmClicked,
    onExistingContactModalCancelClicked,
    onLocalDupPersonModalCancelClicked
  } = usePreCompRegistrationOrganizationContactsDetail();

  return (
    <LeftNav title={PreCompRegistrationConstants.LEFT_NAV_TITLE} state={locationRegistrationNavState} validateBeforeRedirect={false}>
      <Headings.H3>{isDelete ? `Replace ${formState.orgRoleName || 'Contact'}` : 'Add Contact'}</Headings.H3>
      <form onSubmit={handleSubmit} noValidate>
        <PreCompOrganizationContactForm
          formState={formState}
          errorState={errorState}
          roleOptions={roleOptionsState}
          onFormValueChanged={onFormValueChanged}
          onValueTextPairChanged={isDelete ? undefined : onValueTextPairChanged} />
        {errorState.errorOnSubmitAction &&
          <div className="row">
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
            </div>
          </div>}
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="submit">Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={90}
        maxWidth={1020}
        title={"Organization Contact Dupe Check"}
        displayPopUp={dupGridState.length > 0}
        onModalCanceled={onModalCancelClicked}>
        <p><b>Database Matches Found</b></p>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PreCompLocationStaffDupGrid
              actionLabel={'Use Existing Person'}
              persons={dupGridState}
              onSelected={onSelectGridPerson} />
          </div>
        </div>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <p><b>Info Provided By User</b></p>
            <PreCompLocationStaffDupGrid
              actionLabel={'Create New Person'}
              persons={newGridState}
              onSelected={onSelectGridPerson} />
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <PrimaryButton type="button" onClick={onModalContinueClicked}>Continue</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={90}
        maxWidth={1020}
        title={`Replace Current ${existingContactModalState.existingContactOrgRoleName}?`}
        displayPopUp={existingContactModalState.displayModal === true}
        onModalCanceled={onModalCancelClicked}>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <p>Current {existingContactModalState.existingContactOrgRoleName} is {existingContactModalState.existingContactFirstName} {existingContactModalState.existingContactLastName}. Are you sure you want to replace them?</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onExistingContactModalConfirmClicked}>Yes, Save</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onExistingContactModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={90}
        maxWidth={1020}
        title={'Duplicate Contact Detected'}
        displayPopUp={displayLocalDupPersonModalState === true}
        onModalCanceled={onLocalDupPersonModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p>{formState.firstName} {formState.lastName} ({formState.birthDate}) is already a contact.</p>
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <SecondaryButton type="button" onClick={onLocalDupPersonModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </LeftNav>
  );
};

export default PreCompRegistrationOrganizationContactsDetail;